import request from '@/assets/util/request'   //ajax请求

export const storeList = (data)=> {
    return request({
        url: `/agent/api/store/list`,
        method: 'post',
        data: data,
        params:data
    })
}


export const storeDetail = (data)=> {
    return request({
        url: `/agent/api/store/${data.id}`,
        method: 'get',
        data: data,
        params:data
    })
}